<template>
  <div>
    <br />
    <p
      class="ant-descriptions-title"
      style="text-align: center; margin-top: 10px;"
    >
      <marquee behavior="" direction="">
        {{ appConfigOrganization.slogan }}
      </marquee>
    </p>
    <a-divider orientation="left">App</a-divider>
    <a-skeleton active :loading="loadingList" :paragraph="{ rows: 4 }">
      <a-row
        :gutter="[16, 16]"
        style="text-align: center;"
        v-if="appInPlatforms.length > 0"
      >
        <a-col
          :span="12"
          class="test"
          v-for="item in appInPlatforms"
          :key="item.id"
        >
          <a
            :href="item.url"
            :target="item.openNewTab ? '_blank' : ''"
            @click="close"
          >
            <a-card style="border: 0;" hoverable>
              <img
                :alt="item.name"
                :src="item.iconUrl"
                width="50%"
                style="padding: 5px; width: 50px; height: 50px;"
              />

              <div
                style="
                  margin-top: 10px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                "
              >
                {{ item.name }}
              </div>
            </a-card>
          </a>
        </a-col>
      </a-row>
      <a-empty v-else />
    </a-skeleton>
  </div>
</template>
<style lang="scss" scoped>
.test {
  padding: 5px;
  // &:hover {
  //   border: 1px solid rgba(235, 235, 235, 1);
  //   -webkit-box-shadow: 2px 2px 2px 0px rgba(235, 235, 235, 1);
  //   -moz-box-shadow: 2px 2px 2px 0px rgba(235, 235, 235, 1);
  //   box-shadow: 2px 2px 2px 0px rgba(235, 235, 235, 1);
  // }
}
</style>
<script>
import query from "../constants/query";
export default {
  props: {
    appConfigOrganization: {
      type: Object,
      default() {
        return {};
      },
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loadingList: false,
      appInPlatforms: [],
      listApp: [
        { id: 1, name: "Ứng dụng ", icon: "highlight" },
        { id: 2, name: "Ứng dụng ", icon: "play-circle" },
        { id: 3, name: "Ứng dụng ", icon: "highlight" },
        { id: 4, name: "Ứng dụng ", icon: "play-circle" },
        { id: 5, name: "Ứng dụng ", icon: "highlight" },
        { id: 6, name: "Ứng dụng ", icon: "play-circle" },
      ],
    };
  },
  methods: {
    onGetMyAppInPlatform() {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getMyAppInPlatform,
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getMyAppInPlatform) {
            this.appInPlatforms = [...data.getMyAppInPlatform];
          }
          this.loadingList = false;
        })
        .catch((error) => {
          this.loadingList = false;
          console.log("Không lấy được danh sách", error);
        });
    },
  },
  created() {
    this.onGetMyAppInPlatform();
  },
};
</script>
